import React, { useEffect, useState } from 'react'
import Container from '../../../ui/comp/Container'
import { useMutation } from '@tanstack/react-query'
import { Axios, baseURL } from '../../../utils/Axios'
import toast from 'react-hot-toast'
import Button from '../../../ui/comp/Button'
import Input from '../../../ui/forms/Input'
import { displayImage } from '../../../utils/config'
import axios from 'axios'

function Banner() {

    const [bannerData, setBannerData] = useState([])

    const [currentTab, setCurrentTab] = useState(0)

    useEffect(() => {

        const fetchData = async () => {
            try {
                const res = await Axios.get('/store/banner');
                const data = await res.data
                setBannerData(Array(3).fill({ image: "", title: "", sub_title: "", link_name: "", link_url: "", description: "" }).map((val, i) => {
                    return data[i] || val
                }))
            } catch (error) {
                toast.dismiss()
                toast.error(error?.response?.data || error?.message)
            }
        }
        fetchData()

    }, [])

    // File Successfully
    const setFiles = (file, index) => {
        toast.success('File Uploaded')
        const updatedArray = bannerData.map((data, i) => i === index ? { ...data, image: file[0] } : data);
        setBannerData(updatedArray)
    }


    // input onchage

    // Handle input change
    const inputChange = (index, field, value) => {
        const updatedArray = bannerData.map((item, i) =>
            i === index ? { ...item, [field]: value, } : item
        );
        setBannerData(updatedArray);
    };


    // uploading file

    const fileChangeBanner = async (files, i) => {
        if (files?.length) {
            const file = new FormData();

            Object.keys(files).forEach(key => {
                file.append('file', files[key])
            })
            try {
                const res = await axios.post(`${baseURL}/upload`, file)
                const data = await res.data;
                setFiles(data, i)
            } catch (error) {
                toast.error(error?.response?.data || "Error while uploading file")
            }
        }
    }


    // Send Data

    const { mutate, isPending } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/store/banner', formData)
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
        onSuccess: () => {
            toast.success("Header updated")
        }
    })

    const sendData = () => {
        mutate({ data: JSON.stringify(bannerData) })
    }


    return (
        <div className='w-full relative'>
            <Container title={"Banner"}>

                {/* Tabs */}
                <div className='w-full mt-1 flex items-center gap-4 border-b border-gray-900 text-sm'>
                    {Array.from({ length: 3 }).map((_, i) => (
                        <button onClick={() => setCurrentTab(i)}
                            className={`py-4 ${currentTab === i && 'text-primary font-medium'}`}
                            key={i}>
                            Banner {i + 1}
                        </button>
                    ))}
                </div>

                <div className="w-full mt-6">
                    {bannerData.map((data, i) => i === currentTab ? (
                        <div className="space-y-4">
                            {/* Image */}
                            <div className="flex items-center gap-3">
                                <div className="w-32"> <p>Image</p></div>
                                <div className="w-full">
                                    <input type="file" id='file' onChange={(e) => fileChangeBanner(e.target.files, i)} />
                                    <div className="mt-2">
                                        <img src={displayImage(data?.image)} alt="" className="w-24 p-1 border" />
                                    </div>
                                </div>
                            </div>

                            {/* Title */}
                            <div className="flex items-center gap-3">
                                <div className="w-32"> <p>Title</p></div>
                                <div className="w-full">
                                    <Input value={data?.title} onChange={(e) => inputChange(i, "title", e.target.value)} />
                                </div>
                            </div>

                            {/* Subtitle */}
                            <div className="flex items-center gap-3">
                                <div className="w-32"> <p>Sub Title</p></div>
                                <div className="w-full">
                                    <Input value={data?.sub_title} onChange={(e) => inputChange(i, "sub_title", e.target.value)} />
                                </div>
                            </div>

                            {/* Description */}
                            <div className="flex items-center gap-3">
                                <div className="w-32"> <p>Description</p></div>
                                <div className="w-full">
                                    <Input value={data?.description} onChange={(e) => inputChange(i, "description", e.target.value)} />
                                </div>
                            </div>

                            {/* Link Name */}
                            <div className="flex items-center gap-3">
                                <div className="w-32">  <p>Link Name</p></div>
                                <div className="w-full">
                                    <Input value={data?.link_name} onChange={(e) => inputChange(i, "link_name", e.target.value)} />
                                </div>
                            </div>
                            {/* Link URL */}
                            <div className="flex items-center gap-3">
                                <div className="w-32"> <p>Link URL</p></div>
                                <div className="w-full">
                                    <Input value={data?.link_url} onChange={(e) => inputChange(i, "link_url", e.target.value)} />
                                </div>
                            </div>
                        </div>
                    ) : null)}
                </div>

                {/* Bu */}
                <div className="mt-6">
                    <Button onClick={sendData} loading={isPending}>Update</Button>
                </div>
            </Container>
        </div>
    )
}

export default Banner